export enum HttpMethods {
    GET="get",
    POST = 'post',
    PUT = 'put',
    DELETE = 'delete',
    
}